import { render } from "./wordCloud.vue?vue&type=template&id=6be62db4&scoped=true&ts=true"
import script from "./wordCloud.vue?vue&type=script&lang=ts&config=true"
export * from "./wordCloud.vue?vue&type=script&lang=ts&config=true"

import "./wordCloud.vue?vue&type=style&index=0&id=6be62db4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be62db4"]])

export default __exports__